import { Button, Card, CardContent, CardHeader, FormLabel, Grid2, TextField } from "@mui/material";
import { useState } from "react";
import { Commons } from "../../helper/CommonService";
import { API_HOST, STORAGE_KEY } from "../../helper/Constant";
import { useNavigate } from "react-router-dom";
import { Login } from "@mui/icons-material";
import LoadingButton from "@mui/lab/LoadingButton";
import ShowNotif from "../../components/general/ShowNotif";

function LoginAdmin() {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [isShowNotify, setIsShowNotify] = useState(false);
    const [notifyData, setNotifyData] = useState({});
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const LoginAdmin = () => {
        let data = { "email": username, "password": password };
        setIsLoading(true);
        Commons.PostData(API_HOST + "/loginAdmin", data)
            .then((loginResponse) => {
                let newKey = {};
                newKey[STORAGE_KEY.AUTH_ADM] = loginResponse["token"];
                Commons.SaveInStorage(newKey);
                setNotifyData({ message: "Success Login", status: "success" });
                navigate('/progress');
            })
            .catch((loginError) => {
                setNotifyData({ message: "Gagal Login", status: "error" });
                console.log(loginError);
            })
            .finally(() => {
                setIsShowNotify(true);
                setIsLoading(false);
            });
    }
    return (
        <>
            <ShowNotif isShow={isShowNotify} actionClose={() => { setIsShowNotify(false); }} data={notifyData}></ShowNotif>
            <Grid2
                container
                alignItems="center"
                justifyContent="center"
                sx={{ height: "100vh", backgroundColor: "#f4f4f4" }}
            >
                <Card sx={{ padding: 2, maxWidth: 600 }}>
                    <CardHeader title="Login" sx={{ borderBottom: "1px solid #f4f4f4" }}>
                    </CardHeader>
                    <CardContent>
                        <Grid2 container columns={24}>
                            <Grid2 size={12}>
                                <FormLabel sx={{
                                    color: "#000000", fontWeight: "bold"
                                }}>Username</FormLabel>
                                <TextField onChange={(e) => { setUsername(e.target.value); }} name="username" fullWidth></TextField>
                                <br></br>
                                <FormLabel sx={{
                                    color: "#000000", fontWeight: "bold", marginTop: "25px"
                                }}>Password</FormLabel>
                                <TextField onChange={(e) => { setPassword(e.target.value); }} type="password" name="username" fullWidth></TextField>
                                <LoadingButton
                                    color="primary"
                                    loading={isLoading}
                                    loadingPosition="start"
                                    startIcon={<Login />}
                                    variant="contained"
                                    sx={{ mt: '15px' }}
                                    fullWidth
                                    onClick={(e) => {
                                        LoginAdmin();
                                    }}
                                >
                                    {isLoading ? "Processing" : "Login"}
                                </LoadingButton>
                            </Grid2>
                            <Grid2 size={12}>
                                <img width={"300"} src="login.jpg"></img>
                            </Grid2>
                        </Grid2>
                    </CardContent>
                </Card>
            </Grid2>
        </>
    )
}

export default LoginAdmin;